export default "__VITE_ASSET__f2f4afb7__"